<template>
    <view-card headline="실측상세정보" :disabled="!isMeasurer">
        <v-row>
            <v-col cols="7" class="pt-0">
                <v-row>
                    <v-col>
                        <div>공사범위</div>
                        <v-radio-group v-model="isWhole" row hide-details class="mt-0">
                            <v-radio label="전체공사" :value="true" />
                            <v-radio label="부분공사" :value="false" />
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col v-for="{ key, name } in criteria" :key="key" cols="6">
                        <div>{{ name }}</div>
                        <v-radio-group v-model="targets[key]" row hide-details class="mt-0">
                            <v-radio v-for="({ text, value }, i) in options" :key="`option-${i}`" :label="text" :value="value" />
                        </v-radio-group>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="5" class="pt-0">
                <v-textarea v-model="measurerMemo" label="실측자메모" placeholder=" " hide-details rows="12" />
            </v-col>
        </v-row>
        <v-card-actions slot="actions" class="pt-0 px-4 pb-4">
            <v-row justify="end">
                <v-col cols="auto" class="py-0">
                    <v-btn small color="primary" @click="save">저장</v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </view-card>
</template>
<script>
import viewCard from "../dumb/view-card.vue";

const initialTargets = [
    { key: "windows", name: "창호시공" },
    { key: "walls", name: "벽지시공" },
    { key: "floors", name: "바닥재시공" },
    { key: "kitchen", name: "주방시공" },
    { key: "furniture", name: "가구시공" },
    { key: "bathrooms", name: "욕실시공" },
    { key: "doors", name: "도어시공" },
    { key: "middleDoors", name: "중문시공" },
];

export default {
    components: { viewCard },
    props: {
        isMeasurer: { type: Boolean, default: false },
        value: { type: Object, default: null },
    },
    data() {
        return {
            options: [
                { text: "전체", value: 2 },
                { text: "부분", value: 1 },
                { text: "없음", value: 0 },
            ],
            criteria: [...initialTargets],

            isWhole: null,
            targets: {},
            measurerMemo: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.isWhole = this.value.isWhole;
            this.targets = this.value.targets;
            this.measurerMemo = this.value.measurerMemo;
        },
        save() {
            const { isWhole, targets, measurerMemo } = this;
            this.$emit("clickSave", { measurementInfo: { isWhole, targets, measurerMemo } });
        },
    },
    watch: {
        value() {
            this.init();
        },
    },
};
</script>
